import { palette } from "./palette";
import { colors } from "./colors";

export const inputLabel = {
  root: {
    fontSize: "1rem",
    color: "#b4b4b4",
    "&$error": {
      color: "#972323"
    }
  }
};
